export const closeStyle: React.CSSProperties = {
  position: 'absolute',
  right: '12px',
  top: '12px',
  zIndex: 10,
  padding: '0px',
  width: '45px',
  height: '45px',
  cursor: 'pointer',
}
